import { render, staticRenderFns } from "./measurementPointBoxes.vue?vue&type=template&id=7fa09791&scoped=true"
import script from "./measurementPointBoxes.vue?vue&type=script&lang=js"
export * from "./measurementPointBoxes.vue?vue&type=script&lang=js"
import style0 from "./measurementPointBoxes.vue?vue&type=style&index=0&id=7fa09791&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa09791",
  null
  
)

export default component.exports